export const COLORS = {
  // Ethiopian traditional theme - Darker brown tones
  PRIMARY: 0x5D4037,        // Dark brown
  PRIMARY_LIGHT: 0x8B4513,  // Saddle brown
  PRIMARY_DARK: 0x3E2723,   // Very dark brown
  
  SECONDARY: 0x6D4C41,      // Brown
  SECONDARY_LIGHT: 0x8B4513, // Saddle brown
  SECONDARY_DARK: 0x4E342E,  // Dark brown
  
  ACCENT: 0xFFD700,         // Gold (Ethiopian gold)
  ACCENT_LIGHT: 0xFFD700,    // Gold
  ACCENT_DARK: 0xB8860B,    // Dark goldenrod
  
  // Darker paper-like background colors
  BACKGROUND_START: 0xD7CCC8,  // Darker parchment
  BACKGROUND_END: 0xA1887F,    // Dark warm brown
  
  TEXT_PRIMARY: 0x3E2723,      // Very dark brown
  TEXT_SECONDARY: 0x5D4034,    // Dark brown
  TEXT_HIGHLIGHT: 0xFFD700,    // Gold
  
  WIN_GOLD: 0xFFD700,          // Gold
  WIN_SILVER: 0xC0C0C0,
  WIN_BRONZE: 0xCD7F32,
  
  BUTTON_GRADIENT_START: 0x5D4037,  // Dark brown
  BUTTON_GRADIENT_END: 0x8B4513,     // Saddle brown
  
  // Frame colors - darker wood/leather look
  FRAME_OUTER: 0x3E2723,     // Very dark brown (wood)
  FRAME_INNER: 0x5D4037,      // Dark brown
  FRAME_BORDER: 0xB8860B,     // Dark goldenrod (gold trim)
  
  REEL_BACKGROUND: 0x4E342E,   // Dark brown
  REEL_BORDER: 0x3E2723,      // Very dark brown
  
  PARTICLE_COLORS: [
    0xFFD700,  // Gold
    0xDAA520,  // Goldenrod
    0xCD853F,  // Peru
    0xFFD700,  // Gold
    0xB8860B,  // Dark goldenrod
    0xD2691E   // Chocolate
  ]
};

export const ANIMATION = {
  SPIN_DURATION: 2000,
  REEL_STOP_DELAY: 200,
  
  BUTTON_HOVER_SCALE: 1.05,
  BUTTON_PRESSED_SCALE: 0.95,
  
  WIN_TEXT_DURATION: 2000,
  WIN_PARTICLE_DURATION: 3000,
  
  COUNTER_DURATION: 500,
  
  PULSE_SPEED: 0.05,
  GLOW_INTENSITY: 0.3
};

export const FONTS = {
  PRIMARY: 'Spenbeb, Georgia, serif',
  SECONDARY: 'Spenbeb, Georgia, serif',
  ANCIENT: 'Spenbeb, Georgia, serif',
  
  TITLE: {
    fontFamily: 'Spenbeb, Georgia, serif',
    fontSize: 48,
    fontWeight: 'bold',
    fill: 0xFFFFFF,
    stroke: { color: 0x000000, width: 4 },
    dropShadow: {
      color: 0x000000,
      blur: 6,
      distance: 3
    }
  },
  
  BODY: {
    fontFamily: 'Spenbeb, Georgia, serif',
    fontSize: 24,
    fill: 0x1B5E20,
    stroke: { color: 0xFFFFFF, width: 1 }
  },
  
  COUNTER: {
    fontFamily: 'Spenbeb, Georgia, serif',
    fontSize: 32,
    fontWeight: 'bold',
    fill: 0xFFD700,
    stroke: { color: 0x000000, width: 3 },
    dropShadow: {
      color: 0x228B22,
      blur: 4,
      distance: 2
    }
  }
};